import { render, staticRenderFns } from "./SidebarSwitcherFilter.vue?vue&type=template&id=50c77d80&scoped=true&"
import script from "./SidebarSwitcherFilter.vue?vue&type=script&lang=js&"
export * from "./SidebarSwitcherFilter.vue?vue&type=script&lang=js&"
import style0 from "./SidebarSwitcherFilter.vue?vue&type=style&index=0&id=50c77d80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c77d80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
